import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  PaginationItem,
  Pagination,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomTextField from "../CustomComponents/CustomTextField";
import "./Accrual.css";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { BranchAction } from "../Store/Branch";
import AccrualCardItems from "./AccrualCardItems";
import { makeStyles } from "@mui/styles";
import AccrualRemark from "./AccrualRemark";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
var deductionsInitialState = {
  paidTotal: 0,
  dueTotal: 0,
  deductionTotal: 0,
  waivedTotal: 0,
  totalDeductionsTotal: 0,
};
const useStyles = makeStyles({
  dataGridContainer: {
    cursor: "pointer",
  },
});
const AdditionalAccrual = () => {
  const dispatch = useDispatch();
  const selectedBranch = useSelector(
    (state) => state.AdditionalFee.selectedBranch
  );
  const userName = useSelector((state) => state.branch.userName);
  const [modifiedMaps, setModifiedmap] = React.useState({});
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [branchName, setBranchName] = useState("");
  const [rows, setRows] = React.useState([]);
  const rowsPerPage = 10;
  const [page, setPage] = React.useState(0);
  const [gridAlert, setGridAlert] = useState("none");
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [girdVisible, setGridVisible] = useState("none");
  const [codeMap, setCodeMap] = useState({});
  const [applicationSearchDisable, setApplicationSearchDisable] =
    useState(true);
  const [customerDetails, setCustomerDetails] = useState({});
  const [branchNameValue, setBranchNameValue] = useState("");
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [referenceNumber, setReferenceNumber] = useState(0);
  const [updateDisable, setUpdateDisable] = useState(true);
  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [currentDate, setCurrentDate] = useState(
    new Date(
      `${new Date().getFullYear()}/${
        new Date().getMonth() + 1
      }/${new Date().getDate()}`
    ).toLocaleDateString("fr-FR")
  );
  const [isClearButtonClicked, setIsClearButtonClicked] = useState(false);
  const [discardOpen, setDiscardOpen] = useState(false);
  const [branchNameNotValid, setBranchNameNotValid] = useState(false);
  const [applicationNumNotValid, setapplicationNumNotValid] = useState(false);
  const [historyData, setHistorydata] = useState({});
  const [deductionsState, setDeductionsState] = useState(
    deductionsInitialState
  );
  const [applicationNumberModifiedValue, setApplicationNumberModifiedValue] =
    useState("");
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [lengthError, setLengthError] = useState(false);
  const [firstCharError, setFirstCharError] = useState(false);
  const [minLetterError, setMinLetterError] = useState(false);
  const [remarkError, setRemarkError] = useState(false);
  const [reasonError, setReasonError] = useState(false);
  const classes = useStyles();
  const [gridLoading, setGridLoading] = React.useState(false);

  //handle cell changed event
  const handleCellChangedEvent = (event) => {
    var selectedValue = event.value ? event.value : 0;
    var validData =
      selectedValue > -1 &&
      selectedValue <= 99999999 &&
      !selectedValue.toString().includes(".");
    const dataMap1 = [];
    let tempValue = { ...historyData };
    var feeName = event.row ? event.row.id : event.id;
    dataRows.forEach((value, index) => {
      if (value.id === feeName && validData) {
        value.additionalAccrual =
          selectedValue > -1 && selectedValue <= 99999999 ? selectedValue : 0;
        if (selectedValue > -1 && modifiedMaps[event.id] !== selectedValue) {
          tempValue[value.code] = selectedValue;
        }
      }
      dataMap1.push(value);
    });
    setHistorydata(tempValue);
    if (validData) {
      getDataCount(dataMap1);
    } else {
      if (selectedValue < 0) {
        setSnackBarMessage("Amount should not be below 0.");
      } else if (selectedValue > 99999999) {
        setSnackBarMessage("Amount should not be exceed 9,99,99,999.");
      } else if (selectedValue.toString().includes(".")) {
        setSnackBarMessage("Decimal value is not acceptable.");
      }
      setShowSnackBar(true);
    }
    setDataRow(dataMap1);
    setUpdateDisable(
      JSON.stringify(modifiedMaps) === JSON.stringify(getModifiedData(dataRows))
    );
  };
  //getFeeData
  const getData = async () => {
    try {
      setGridLoading(true);
      const response = await axios.post("/additionalfee/getFeeData", {
        applicationNum: applicationNum,
        type: "accrual",
        userName: userName,
      });
      setCodeMap(response.data.codeMap);
      getDataCount(response.data.gridData);
      setDataRow(response.data.gridData);
      setPage(0);
      setModifiedmap(getModifiedData(response.data.gridData));
      setReferenceNumber(
        response.data.referenceNumber ? response.data.referenceNumber + 1 : 1
      );
      setUpdateDisable(true);
      setReason("");
      setRemark("");
      setGridVisible("block");
      setGridLoading(false);
    } catch {
      setGridLoading(false);
      setGridVisible("none");
      console.log("Network Error");
    }
  };
  //calculate total count
  const getDataCount = (gridRows) => {
    let paidTotal1 = 0;
    let dueTotal1 = 0;
    let deductionTotal1 = 0;
    let waivedTotal1 = 0;
    let data = { ...deductionsInitialState };
    gridRows.map((rows) => {
      data = {};
      paidTotal1 = paidTotal1 + rows.received;
      dueTotal1 = dueTotal1 + rows.receiveable + rows.additionalAccrual;
      deductionTotal1 =
        deductionTotal1 +
        rows.additionalAccrual +
        (rows.receiveable - rows.received - rows.earlyWaiver);
      waivedTotal1 = waivedTotal1 + rows.earlyWaiver;
      data.paidTotal = paidTotal1;
      data.dueTotal = dueTotal1;
      data.deductionTotal = deductionTotal1;
      data.waivedTotal = waivedTotal1;
      data.totalDeductionsTotal =
        dueTotal1 + deductionTotal1 - paidTotal1 - waivedTotal1;
    });
    setDeductionsState(data);
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  //loadApplicationList
  const getApplicationListData = async (newValue) => {
    try {
      const branchCodeValue = getSelectedBranchCode(newValue.label);
      const response = await axios.post("/additionalfee/getApplicationNumber", {
        branchName: newValue.label,
        branchCode: branchCodeValue,
      });
      setapplicationNumList(response.data);
    } catch {
      setGridVisible("none");
      console.log("Network Error");
    }
  };
  const getModifiedData = (modifiedData) => {
    let modifiedMap = {};
    modifiedData.forEach(function (key) {
      modifiedMap[key["details"]] = key["additionalAccrual"];
    });
    return modifiedMap;
  };
  const [applicationNum, setapplicationNum] = useState("");
  const onChangeCardItems = (row, value) => {
    row["additionalWaiver"] = value;
    setDataRow((oldArray) => [...oldArray, row]);
  };
  //shortcut keys
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const goButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "additionalAccrual",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let refList = {
      goButtonRef: goButtonRef,
      clearRef: clearRef,
    };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "additionalAccural",
        })
      );
    }
  };
  useEffect(() => {
    setRows(dataRows.slice(0, rowsPerPage));
    setTotalPageCount(
      dataRows.length % 10 !== 0
        ? Number(Number((dataRows.length / 10).toFixed()) + 1)
        : Number(Number((dataRows.length / 10).toFixed()))
    );
    setTotalRowsCount(dataRows.length);
    const branchValues = GetBranchDetails();
    setbranchNames(branchValues);
  }, [selectedBranch]);
  const [applicationNumList, setapplicationNumList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [branchNames, setbranchNames] = useState([]);
  const handleSearch = (event) => {
    event.preventDefault();
    if (branchName && applicationNum) {
      getData();
      setGridVisible("block");
    } else {
      branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      applicationNum
        ? setapplicationNumNotValid(false)
        : setapplicationNumNotValid(true);
      setGridVisible("none");
    }
  };
  // discard changes
  const discardChanges = () => {
    setDataRow([]);
    setHistorydata([]);
    setUpdateDisable(true);
    applicationNumberModifiedValue && applicationNumberModifiedValue.label
      ? setapplicationNum(applicationNumberModifiedValue.label)
      : setapplicationNum("");
    dispatch(BranchAction.updateInitialLoad(false));
    if (branchNameValue && branchNameValue.label) {
      dispatch(BranchAction.updateHeaderBranchDetails(branchNameValue.label));
      getApplicationListData(branchNameValue);
    }
    branchNameValue && branchNameValue.label
      ? setBranchName(branchNameValue.label)
      : branchName
      ? setBranchName(branchName)
      : setBranchName("");
    setReferenceNumber("");
    setGridVisible("none");
    setDiscardOpen(false);
    setReason("");
    setRemark("");
    if (branchNameValue === null) {
      setapplicationNum("");
      setapplicationNumList([]);
    }
    if (isClearButtonClicked || branchNameValue === null) {
      setIsClearButtonClicked(false);
      setBranchName("");
    }
    setDiscardOpen(false);
    clearRemarkError();
  };
  //on change event for branch
  const onChangeForBranchEvent = (event, newValue) => {
    if (updateDisable && !reason && !remark) {
      setBranchName(newValue);
      getApplicationListData(newValue);
      if (newValue && newValue.label) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(newValue.label));
      } else {
        setapplicationNumList([]);
      }
      setApplicationSearchDisable(false);
      setBranchNameNotValid(false);
      setapplicationNum("");
      setReferenceNumber("");
      setGridVisible("none");
      setApplicationNumberModifiedValue("");
    } else {
      setApplicationNumberModifiedValue("");
      setBranchNameValue(newValue);
      setDiscardOpen(true);
    }
    // setApplicationSearchDisable(newValue ? false : true);
    setReferenceNumber("");
    clearRemarkError();
  };
  // on change event for application number
  const onChangeForReferenceEvent = (event, newValue) => {
    if (newValue.value !== null || newValue.value !== "") {
      getcustomerDetails(newValue);
    }
    if (updateDisable && !reason && !remark) {
      if (newValue === null) {
        setapplicationNum("");
        setReferenceNumber("");
        setGridVisible("none");
      } else {
        setapplicationNumNotValid(false);
        setapplicationNum(newValue.label);
      }
      setApplicationNumberModifiedValue("");
    } else {
      setBranchNameValue("");
      setApplicationNumberModifiedValue(newValue);
      setDiscardOpen(true);
    }
    clearRemarkError();
  };
  const searchButtonClickHandler = (event) => {
    event.preventDefault();
  };
  const clearRemarkError = () => {
    setRemarkError(false);
    setLengthError(false);
    setFirstCharError(false);
    setMinLetterError(false);
    setReasonError(false);
  };
  const getcustomerDetails = async (value) => {
    const branchCodeValue = getSelectedBranchCode(branchName.label);
    const response = await axios.post(
      "/losCustomer/getLosDetailsByBranchAndAppNum",
      {
        branchName: branchName.label,
        appNum: value.value,
        branchCode: branchCodeValue,
      }
    );
    setCustomerDetails(response.data);
  };
  // on change event for clear button handler
  const clearButtonClickHandler = () => {
    if (updateDisable && !reason && !remark) {
      setBranchName("");
      setUpdateDisable(true);
      setapplicationNum("");
      setGridVisible("none");
      setReferenceNumber("");
      setapplicationNumNotValid(false);
      setBranchNameNotValid(false);
      setApplicationSearchDisable(true);
      setDataRow([]);
      setHistorydata([]);
      setRemark("");
      setRemarkError("");
      setCustomerDetails({});
      setReason("");
      setReasonError("");
    } else {
      setIsClearButtonClicked(true);
      setDiscardOpen(true);
    }
    clearRemarkError();
  };
  //find value is updated or not in grid
  const checkUpdatedValueWithModifiedData = (event, value) => {
    if (modifiedMaps[event["id"]] !== value) {
      setUpdateDisable(false);
    }
  };
  const [dataRows, setDataRow] = React.useState([]);
  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows(dataRows.slice(offset, offset + rowsPerPage));
  };
  const columns = [
    {
      field: "details",
      headerName: "Fee Description",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      flex: 310,
      align: "left",
      editable: false,
    },
    {
      field: "receiveable",
      headerName: "Amount Receivable (₹)",
      headerAlign: "center",
      type: "number",
      hideable: false,
      sortable: false,
      flex: 250,
      align: "right",
      editable: false,
    },
    {
      field: "received",
      headerName: "Amount Received (₹)",
      headerAlign: "center",
      type: "number",
      minWidth: 150,
      align: "right",
      editable: false,
    },
    {
      field: "earlyWaiver",
      headerName: "Earlier Waiver (₹)",
      headerAlign: "center",
      type: "number",
      flex: 190,
      align: "right",
      editable: false,
    },
    {
      field: "additionalAccrual",
      headerName: "Additional Accrual (₹)",
      headerAlign: "center",
      type: "number",
      flex: 190,
      align: "right",
      editable: true,
      valueGetter: (value) => {
        if (value.value <= 0 || value.value > 99999999) {
          return 0;
        } else {
          return value.value;
        }
      },
    },
    {
      field: "outstanding",
      headerName: "Outstanding Amount (₹)",
      headerAlign: "center",
      type: "number",
      flex: 205,
      minWidth: 205,
      editable: false,
      align: "right",
      valueGetter: (param) => {
        let additionalAccrual =
          param.row.additionalAccrual === undefined ||
          param.row.additionalAccrual < 0 ||
          param.row.additionalAccrual > 99999999
            ? 0
            : param.row.additionalAccrual;
        if (
          isNaN(
            param.row.receiveable -
              param.row.received +
              additionalAccrual -
              +param.row.earlyWaiver
          )
        ) {
          return 0;
        } else {
          return (
            param.row.receiveable -
            param.row.received +
            additionalAccrual -
            +param.row.earlyWaiver
          );
        }
        {
        }
      },
    },
  ];
  let visibility = {
    due: false,
    earlyWaiver: false,
    additionalWaiver: false,
    outstanding: false,
  };
  if (window.innerWidth > 700) {
    visibility = {};
  }
  return (
    <div>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord"
            title="Fee Accrual Details"
            initialOpen={true}
            sx={{ margin: "8px !important", width: "100%" }}
          >
            <Box
              id="accord-box"
              component="form"
              validate="true"
              onSubmit={searchButtonClickHandler}
            >
              <form>
                <Grid
                  item
                  container
                  spacing={1}
                  sx={{ marginTop: "-36px !important", width: "100%" }}
                >
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomAutoComplete
                      required={true}
                      label="Branch"
                      id="branchName"
                      variant="standard"
                      value={branchName}
                      onChange={(event, newValue) =>
                        onChangeForBranchEvent(event, newValue)
                      }
                      type="text"
                      placeholder="Branch"
                      autoCompleteValues={branchNames}
                    />
                    {branchNameNotValid && (
                      <p className="error">Please Select Branch</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomAutoComplete
                      required={true}
                      clearText={() => console.log("log")}
                      disabled={branchName === null || branchName === ""}
                      label="Application Number"
                      id="applicantName"
                      variant="standard"
                      value={applicationNum}
                      onChange={(event, newValue) => {
                        onChangeForReferenceEvent(event, newValue);
                      }}
                      // value={applicantName}
                      type="text"
                      placeholder="Application Number"
                      autoCompleteValues={applicationNumList}
                    />
                    {applicationNumNotValid && (
                      <p className="error">Please Select Application Number</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomTextField
                      disabled={true}
                      label="Customer IDs"
                      id="id"
                      type="text"
                      placeholder="Customer ID"
                      variant="standard"
                      value={
                        Object.keys(customerDetails).length > 0
                          ? customerDetails?.customerId
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomTextField
                      disabled={true}
                      label="Applicant Name"
                      id="name"
                      type="text"
                      placeholder="Applicant Name"
                      variant="standard"
                      value={
                        Object.keys(customerDetails).length > 0
                          ? customerDetails?.customerName
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomTextField
                      disabled={true}
                      label="Reference Number"
                      id="refno"
                      type="text"
                      placeholder="Reference Number"
                      required={false}
                      variant="standard"
                      value={referenceNumber === 0 ? "" : referenceNumber}
                      // onChange={trnNoChangeHandler}
                      // onChange={(event)=>setReferenceName(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <CustomTextField
                      required={false}
                      disabled={true}
                      label="Reference Date"
                      id="refdate"
                      value={currentDate}
                      type="text"
                      placeholder=""
                      variant="standard"
                    />
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    margin: "8px 0px 4px 0px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Ctrl+F" placement="top">
                    <Button
                      sx={{ fontWeight: "bold", height: "2rem" }}
                      variant="contained"
                      type="submit"
                      onClick={(event) => handleSearch(event)}
                      ref={searchButtonRef}
                    >
                      Search
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ctrl+D" placement="top">
                    <Button
                      sx={{
                        marginLeft: "8px",
                        color: "white",
                        backgroundColor: "black",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      onMouseOver={({ target }) => {
                        target.style.backgroundColor = "black";
                        target.style.color = "white";
                      }}
                      variant="contained"
                      onClick={() => clearButtonClickHandler()}
                      ref={clearRef}
                    >
                      Clear
                    </Button>
                  </Tooltip>
                </Box>
              </form>
            </Box>
          </AccordianContainer>
        </Grid>
        <div
          style={{
            display: girdVisible,
            width: "calc(100% - 8px)",
            paddingTop: "8px",
          }}
        >
          {useMediaQuery("(min-width:1200px)") && (
            <AccordianContainer
              id="accord"
              title="Accrual Details"
              initialOpen={true}
              sx={{ marignBottom: "8px !important" }}
            >
              <Grid container spacing={0}>
                <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Total Outstanding (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.deductionTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Receivable (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.dueTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Received (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.paidTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Early Waived (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.waivedTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Outstanding (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.deductionTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                  </label>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                // columns={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6 }}
                sx={{
                  width: "calc(100% - 8px)",
                  margin: "unset",
                  display: girdVisible,
                  backgroundColor: "#fff",
                }}
              >
                <div className={classes.dataGridContainer}>
                  <DataGrid
                    sx={{
                      boxShadow: 2,
                      border: 2,
                      minHeight: "305px",
                      borderColor: "white",
                      "& .MuiDataGrid-columnHeaders": {
                        color: "white",

                        backgroundColor: "#004A92",
                      },
                    }}
                    id="feedatagrid"
                    rowThreshold={0}
                    rowHeight={40}
                    headerHeight={48}
                    disableSelectionOnClick
                    loading={dataRows.length === 0 || gridLoading}
                    rows={dataRows}
                    page={page}
                    columns={columns}
                    pageSize={pageSize}
                    onPageChange={(event) => setPage(event)}
                    onCellEditCommit={(event) => handleCellChangedEvent(event)}
                    onCellKeyDown={(event, param) => {
                      (param.key === "e" || param.key === "E") &&
                        param.preventDefault();
                      checkUpdatedValueWithModifiedData(
                        event,
                        param.target.value
                      );
                      // if (
                      //   (param.ctrlKey || param.metaKey) &&
                      //   param.keyCode == 86
                      // ) {
                      //   param.preventDefault();
                      // }
                    }}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          ...visibility,
                        },
                      },
                    }}
                  />
                </div>
              </Grid>
            </AccordianContainer>
          )}
          {useMediaQuery("(max-width:1200px)") && (
            <React.Fragment>
              <Grid
                container
                item
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-end"
                sx={{ height: "60px", bgcolor: "white" }}
              >
                {totalRowsCount > 10 && (
                  <Typography
                    sx={{
                      mr: 2,
                      color: "#004A92",
                      fontWeight: 700,
                    }}
                  >
                    {"Page Max Records : " + rowsPerPage}
                  </Typography>
                )}
                <Typography
                  padding="1px"
                  sx={{
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Total Records : " + totalRowsCount}
                </Typography>
                <Pagination
                  count={totalPageCount}
                  color="primary"
                  onChange={handlePageChange}
                  page={page}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{ previous: ArrowBack, next: ArrowForward }}
                      {...item}
                    />
                  )}
                />
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    height: accordianOpen
                      ? window.innerHeight - 540
                      : window.innerHeight - 250,
                    overflow: "auto",
                    flex: "1 auto",
                  }}
                >
                  {dataRows.map((row, index) => (
                    <AccrualCardItems
                      value={row}
                      index={index}
                      onChange={onChangeCardItems}
                      screen="accrual"
                      setGridAlert={setGridAlert}
                    ></AccrualCardItems>
                  ))}
                </Box>
              </Grid>
            </React.Fragment>
          )}
          <AccrualRemark
            name="Accrued By"
            gridData={dataRows}
            codeMap={codeMap}
            refNum={referenceNumber}
            branchName={branchName}
            applicationNum={applicationNum}
            refDate={currentDate}
            type="accrual"
            reason={reason}
            setReason={setReason}
            setRemark={setRemark}
            remark={remark}
            remarkError={remarkError}
            minLetterError={minLetterError}
            lengthError={lengthError}
            firstCharError={firstCharError}
            setRemarkError={setRemarkError}
            setMinLetterError={setMinLetterError}
            setLengthError={setLengthError}
            setFirstCharError={setFirstCharError}
            historyData={historyData}
            setReasonError={setReasonError}
            reasonError={reasonError}
            updateDisable={updateDisable}
            discardChanges={discardChanges}
            discardOpen={discardOpen}
            setDiscardOpen={setDiscardOpen}
            message={"Additional Fee Details Update ?"}
            girdVisible={girdVisible}
            searchButtonRef={searchButtonRef}
            clearRef={clearRef}
          ></AccrualRemark>
          <CustomSnackBar
            showSnackbar={showSnackBar}
            autoHideDuration={5000}
            onClose={() => {
              setShowSnackBar(false);
            }}
            message={snackBarMessage}
            severity="warning"
            color={"red"}
          />
          <CustomSnackBar
            showSnackbar={showSnackBar}
            autoHideDuration={6000}
            onClose={() => {
              setShowSnackBar(false);
            }}
            message={snackBarMessage}
            severity="error"
          />
        </div>
      </div>
      <StlapFooter />
    </div>
  );
};
export default AdditionalAccrual;
